import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";
import {parseCarouselsFromResponse} from "../../../util/carousels/parseCarouselsResponse";
import {formatQueryParams} from "../../../util/queryParams";

const buildCarouselQueryString = (params = {}) => {
  const merged = {
    page: 1,
    page_size: 50,
    sort: "desc",
    ...params,
    with_games: "true",
  };

  const cleaned = Object.fromEntries(
    Object.entries(merged).filter(([, value]) => value !== "" && value !== undefined && value !== null)
  );

  return formatQueryParams([cleaned]);
};

/**
 * BO carousels with games. Falls back to public /v1/carousels when BO returns empty
 * (common when the user token cannot access backoffice routes).
 */
export const getCarouselsGamesService = async (params = {}) => {
  const queryString = buildCarouselQueryString(params);
  const boUrl = `${ConfEnv.API_CAROUSELS.URL_CAROUSELS}${queryString}`;

  try {
    const boResponse = await privateRequest.get(boUrl, undefined, undefined, undefined, {
      skipSessionLogout: true,
    });
    const boCarousels = parseCarouselsFromResponse(boResponse);
    if (boCarousels.length > 0) {
      return boResponse;
    }
  } catch (boError) {
    if (import.meta.env.DEV) {
      console.warn("[CustomCarousels] BO carousels request failed, trying public endpoint.", boError);
    }
  }

  const publicUrl = `${ConfEnv.API_CAROUSELS.URL_CAROUSELS}${queryString}`;
  return privateRequest.get(publicUrl);
};
